import { msg } from '@gonfalon/messages/msg';
import { Dialog, DialogTrigger, Heading, IconButton, Modal, ModalOverlay } from '@launchpad-ui/components';

import { getMaxYValue, UsageDetailChart } from '../../charts/UsageDetailChart';

import { GroupedUsageCard, type GroupedUsageCardProps } from './UsageDetailGrouped';

export type DataExportBreakdownChartCardProps = Omit<
  GroupedUsageCardProps,
  'metadataIdx' | 'metadataKey' | 'limitValue' | 'precomputedTitle' | 'isTitleFocusable'
> & {
  label: string;
};

export function DataExportBreakdownChartCard({
  label,
  dimension,
  yAxisMax,
  timestamps,
  ...shared
}: DataExportBreakdownChartCardProps) {
  return (
    <DialogTrigger>
      <GroupedUsageCard
        {...shared}
        metadataIdx={0}
        dimension={dimension}
        metadataKey={dimension}
        timestamps={timestamps}
        limitValue={0}
        yAxisMax={yAxisMax}
        precomputedTitle={label}
        isTitleFocusable={false}
        titleAction={
          <IconButton
            aria-label={msg('billing.dataExportCombined.viewGroupUsage', { name: label })}
            icon="arrows-diagonal-expand-tl-br"
            size="small"
            variant="minimal"
          />
        }
      />
      <ModalOverlay>
        <Modal size="large">
          <Dialog>
            <div slot="header">
              <Heading slot="title">{label}</Heading>
              <IconButton
                aria-label={msg('billing.dataExportCombined.closeLabel')}
                icon="cancel"
                size="small"
                variant="minimal"
                slot="close"
              />
            </div>
            <div slot="body">
              <UsageDetailChart
                {...shared}
                size="large"
                condenseLabels={false}
                fromTimestampUTC={timestamps.from}
                toTimestampUTC={timestamps.to}
                cutoffTimestampUTC={timestamps.cutoff}
                yAxisMax={getMaxYValue(shared.data.series, shared.precision)}
              />
            </div>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
}
